import Link from 'next/link';
import { useRouter } from 'next/router';
import LazyLoad from 'react-lazyload';
import { intToString, removeDefaultParams } from '../../../Utils/helper';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import { PostAndFollowers } from '../../CategoryDetail/TopicInfo/styled';
import { getSearchParams } from '../../Parenting/common';
import {
  CardBox,
  CardName,
  Content,
  ContentSection,
  TopicListImage,
} from './styled';
import { fireClickedCardEvent } from '../../../Utils/useFirebase';

function TopicCard(props) {
  const {
    data,
    title,
    isStagePage,
    itemIndex,
    setGridCardSignal,
    gridCardSignal,
    parentTag,
  } = props;
  const router = useRouter();
  const postCount = intToString(data?.contentCount);
  const followerCount = intToString(data?.following);

  return (
    <CardBox>
      <Link
        href={{
          pathname: data?.web_url,
          query: removeDefaultParams(router.query),
        }}
        passHref
        locale={false}
      >
        <div
          onClick={(e) => {
            fireClickedCardEvent(
              title,
              data?.description,
              'Topic List',
              data?.term_id,
              data?.web_url,
              data?.web_url,
              parentTag,
            );
            e.preventDefault();
            setTimeout(() => {
              router.push(data?.web_url + getSearchParams(), '', {
                locale: getRouterLocale(router),
              });
            }, [200]);

            setGridCardSignal({
              index: itemIndex,
              show: true,
            });
          }}
          className={
            gridCardSignal?.index === itemIndex
              ? 'gridcardopacity transitionClass'
              : 'transitionClass'
          }
        >
          <LazyLoad height={100} once offset={100}>
            <TopicListImage
              src={`${data?.image}?tr=w-360,q-90`}
              srcSet={`${data?.image}?tr=w-360,q-90 2w, ${data?.image}?tr=w-500,q-90 720w`}
              sizes="(max-width: 720px) 2px,720px"
              alt={data?.description}
              loading="lazy"
            />
          </LazyLoad>
          <ContentSection>
            <CardName>{data?.description}</CardName>
            {isStagePage ? (
              <PostAndFollowers padding="0 0 8px" topicListing>
                <PostAndFollowers topicListing>
                  <img src="/images/comment_dark.svg" loading="lazy" alt="" />
                  <span>
                    {postCount}{' '}
                    {data?.contentCount > 1 ? (
                      <span className="hideMweb">Posts</span>
                    ) : (
                      <span className="hideMweb">Post</span>
                    )}
                  </span>
                </PostAndFollowers>

                <PostAndFollowers topicListing>
                  <img src="/images/people_group.svg" loading="lazy" alt="" />
                  <span>
                    {followerCount}{' '}
                    {data?.following > 1 ? (
                      <span className="hideMweb">Followers</span>
                    ) : (
                      <span className="hideMweb">Follower</span>
                    )}
                  </span>
                </PostAndFollowers>
              </PostAndFollowers>
            ) : null}

            <Content>{data?.meta_description}</Content>
          </ContentSection>
        </div>
      </Link>
    </CardBox>
  );
}

export default TopicCard;
